var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-nav-item j-nav-item",
      class: { "c-nav-item--mobile": _vm.isMobile }
    },
    [
      _vm.isJustALink
        ? _c(
            "nuxt-link",
            {
              staticClass: "c-nav-item__navigation t-heading-6",
              class: { "c-nav-item__navigation--padding": _vm.isMobile },
              attrs: { to: _vm.item.url, tabindex: _vm.myIndex + 1 }
            },
            [
              _vm._v("\n    " + _vm._s(_vm.item.title) + "\n    "),
              _vm.isMobile
                ? _c("img", {
                    staticClass: "c-nav-item__navigation--right",
                    attrs: {
                      src: require("../../assets/icons/nav-arrow.svg"),
                      alt: ""
                    }
                  })
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isJustALink
        ? _c(
            "button",
            {
              staticClass: "c-nav-item__navigation",
              class: { "c-nav-item__navigation--padding": _vm.isMobile },
              attrs: { type: "button", tabindex: _vm.myIndex + 1 },
              on: { click: _vm.showSubMenu, mouseover: _vm.hoverShow }
            },
            [
              _c("span", { staticClass: "t-heading-6" }, [
                _vm._v(_vm._s(_vm.item.title))
              ]),
              _vm._v(" "),
              _vm.isMobile
                ? _c("img", {
                    staticClass: "c-nav-item__navigation--right",
                    attrs: {
                      src: require("../../assets/icons/nav-arrow.svg"),
                      alt: ""
                    }
                  })
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.drawingMenu
        ? _c(
            "div",
            {
              staticClass:
                "c-nav-item__menu u-background-color-base j-nav-item__menu",
              class: {
                "c-nav-item__menu--showing": _vm.showingMenu,
                "c-nav-item__menu--desktop": !_vm.isMobile
              }
            },
            [
              _vm.isMobile
                ? _c(
                    "header",
                    {
                      staticClass:
                        "c-nav-item__header j-nav-item__header t-heading-6"
                    },
                    [_vm._v("\n      " + _vm._s(_vm.item.title) + "\n    ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-nav-item__scroll j-nav-item__scroll" },
                [
                  _c(
                    "div",
                    [
                      _vm.item.secondaryNavItems && !_vm.isMobile
                        ? _c("secondary-nav", {
                            staticClass: "c-nav-item__secondary--desktop",
                            attrs: {
                              "nav-items": _vm.item.secondaryNavItems,
                              "tabindex-start": _vm.tabindexStart + 1
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.navItems
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "c-nav-item__cards l-grid l-grid--3-col",
                              class: {}
                            },
                            _vm._l(_vm.item.navItems, function(navItem, index) {
                              return _c("nav-card", {
                                key: "c-nav-card_" + index,
                                staticClass: "c-nav-item__card",
                                attrs: {
                                  "nav-item": navItem,
                                  tabindex:
                                    _vm.tabindexStart +
                                    _vm.calculateCardTabIndex(_vm.item) +
                                    1 +
                                    index
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.secondaryNavItems && _vm.isMobile
                        ? _c("secondary-nav", {
                            staticClass: "c-nav-item__secondary--mobile",
                            attrs: {
                              "nav-items": _vm.item.secondaryNavItems,
                              "tabindex-start": _vm.tabindexStart + 1
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }